import React from "react";
import "./FifthSection.css";

const FifthSection = () => {
  return (
    <div className="fifth_section_parent_div">
      <h4 className="testimonials">Testimonials</h4>
      <div className="fifth_section_grid_div">
        <div className="testimonial_one_div">
          <p className="testimonial_p">Testimonial 1</p>
          <div className="testimonial_one_parent_div">
            <p>
              I reached out for help because I was in a toxic friendship.
              Because of how depressed I was I stayed in it even though I was
              being used by her. This prevented me from doing many of the things
              I should have been doing for myself.
            </p>
            <p>
              Tiffany did an incredible job of understanding my emotions. She
              understood that just because I am a guy, it does not mean my heart
              can’t break or be destroyed. She said everything I was hoping to
              hear and eased my frustrations for wanting revenge.{" "}
            </p>
            <p>
              Tiffany is one of a kind, caring, understanding, and she has
              knowledge and will see things from your perspective. I now feel
              better moving on with my life knowing my self-worth while working
              on my own goals.
            </p>
          </div>
        </div>
        <div className="testimonial_two_div">
          <p className="testimonial_p">Testimonial 2</p>
          <div className="testimonial_two_parent_div">
            <p>
              I was living with my ex and kids’ mother while she has moved on
              with another man. I didn’t want to be there although I still had
              feelings for her. I had nowhere to go plus needed to be there for
              the kids.
            </p>
            <p>
              Tiffany encouraged me to give myself space and to allow myself to
              feel how I feel. She helped me understand it’s okay to feel my
              emotions, while at the same time eliminating all distractions (TV,
              video games, other women).
            </p>
            <p>
              I decided to leave and take time for myself and to think about
              what I wanted. That time away helped me to self-reflect and to get
              over my ex. Now I visit my kids without feeling angry, hurt, or
              lost.
            </p>
          </div>
        </div>
        <div className="testimonial_three_div">
          <p className="testimonial_p">Testimonial 3</p>
          <div className="testimonial_three_parent_div">
            <p>
              I caught my girlfriend cheating. I was frustrated because I didn’t
              know how to bring up the fact that I saw the text messages.
            </p>
            <p>
              Tiffany listened and understood my problem and helped me process
              the feelings that I was pushing away.
            </p>
            <p>
              Our sessions helped because I was able to confront my girlfriend
              in a way that didn’t worsen the situation. I feel better now that
              I can move forward to handle challenges without blowing up in
              anger and doing things I would regret.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FifthSection;
